/*=============================
=             Menu            =
=============================*/

var menu = document.getElementById("menu"),
    mobileMenuButton = document.getElementById("mobile-menu-button"),
    popupMenu = document.getElementById("popup-menu"),
    getStarted = document.querySelector(".get-started");

body.addEventListener("click", function (e) {
    checkAndCloseMenu(e.target);
});

mobileMenuButton.addEventListener("click", function (e) {
    e.preventDefault();
    //Velocity(popupMenu, 'fadeIn', {duration: 500, display: 'block'});
    togglePopupMenu();
    if (document.querySelector(".get-started.open")) {
        document.querySelector(".get-started.open button").click();
    }
});

document
    .querySelector("#popup-menu .close_button.open")
    .addEventListener("click", function (e) {
        e.preventDefault();
        //Velocity(popupMenu, 'fadeOut', {duration: 500, display: 'none'});
        togglePopupMenu();
    });

function togglePopupMenu() {
    if (body.classList.contains("menu-open")) {
        Velocity(popupMenu, "fadeOut", { duration: 500, display: "none" });
        toggleMenuBodyClass(false);
    } else {
        Velocity(popupMenu, "fadeIn", { duration: 500, display: "block" });
        toggleMenuBodyClass(true);
    }
}

document.addEventListener("keydown", function (e) {
    if (e.key == "Escape") checkAndCloseMenu(menu);
});

function checkAndCloseMenu(e) {
    var open = openMenu(e);

    if (open) {
        closeMenu(open);
    }
}

document
    .querySelector(".get-started button")
    .addEventListener("click", function (el) {
        let parent = this.parentNode,
            isOpen = parent.classList.contains("open");
        parent.classList.toggle("open");
    });

[].slice
    .call(
        document.querySelectorAll(
            "#cta-links button:not(.lang-button), #popup-menu button:not(.lang-button):not(#search-button):not(.close_button)"
        )
    )
    .forEach(function (navLink) {
        navLink.addEventListener("click", toggleMenu);
    });

function toggleMenu() {
    closeMenu(openMenu(this));

    var parent = this.parentNode.parentNode,
        openSibling = parent.querySelector(".open"),
        isOpen = this.classList.contains("open");

    if (
        parent.classList.contains("submenu") &&
        openSibling &&
        openSibling != this
    )
        closeMenu(openSibling);

    Velocity(this.nextElementSibling, isOpen ? "slideUp" : "slideDown", {
        duration: 300,
        display: !isOpen ? "flex" : "none",
    });

    this.classList.toggle("open");

    this.setAttribute(
        "aria-expanded",
        this.getAttribute("aria-expanded") == "true" ? "false" : "true"
    );
}

function closeMenu(el) {
    if (el) {
        var submenu = el.nextElementSibling;

        Velocity(submenu, "slideUp", { duration: 150 });

        el.classList.remove("open");

        closeMenu(submenu.querySelector(".open"));
    }
}

function openMenu(el) {
    var openButton = popupMenu.querySelector(
        "button.open:not(#mobile-menu-button)"
    );

    return openButton && !openButton.parentNode.contains(el)
        ? openButton
        : false;
}

function toggleMenuBodyClass(open) {
    if (open) body.classList.add("menu-open");
    else body.classList.remove("menu-open");

    setFocus(open ? true : false, header);
}

function setFocus(open, container) {
    [].slice
        .call(document.querySelectorAll("#header, #hero, #main, #footer"))
        .forEach(function (parent) {
            if (parent != container) {
                parent.setAttribute("aria-hidden", open);

                [].slice
                    .call(parent.querySelectorAll("a, button, input"))
                    .forEach(function (link) {
                        if (open) link.setAttribute("tabindex", "-1");
                        else link.removeAttribute("tabindex");
                    });
            }
        });
}
